import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=6dfe94ba&lang=pug&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dfe94ba')) {
      api.createRecord('6dfe94ba', component.options)
    } else {
      api.reload('6dfe94ba', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=6dfe94ba&lang=pug&", function () {
      api.rerender('6dfe94ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/Product.vue"
export default component.exports